import * as XLSX from "xlsx";
import html2canvas from "html2canvas";

/**
 * Exports data to an Excel file (.xlsx)
 * @param {Array} data - Array of objects to be exported
 * @param {string} fileName - Name of the file (without extension)
 * @param {string} sheetName - Name of the worksheet
 */
export const exportToExcel = (data, fileName = "data", sheetName = "Sheet1") => {
    if (!data || !data.length) return;

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Write and download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

/**
 * Exports data to a CSV file (.csv)
 * Handles UTF-8 with BOM for better Excel compatibility
 * @param {Array} data - Array of objects to be exported
 * @param {string} fileName - Name of the file (without extension)
 */
export const exportToCSV = (data, fileName = "data") => {
    if (!data || !data.length) return;

    let worksheet;
    if (Array.isArray(data[0])) {
        // Data is an array of arrays (aoa) - e.g. [[header1, header2], [val1, val2]]
        worksheet = XLSX.utils.aoa_to_sheet(data);
    } else {
        // Data is an array of objects (json) - e.g. [{header1: val1, header2: val2}]
        worksheet = XLSX.utils.json_to_sheet(data);
    }
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    // Adding BOM (Byte Order Mark) for UTF-8 to ensure Excel opens it correctly with Arabic characters
    const bom = "\uFEFF";
    const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${fileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

/**
 * Exports a DOM element as an image (.png)
 * @param {string} elementId - ID of the element to capture
 * @param {string} fileName - Name of the file (without extension)
 */
export const exportElementAsImage = async (elementId, fileName = "chart") => {
    const element = document.getElementById(elementId);
    if (!element) {
        console.error(`Element with id ${elementId} not found`);
        return;
    }

    try {
        const canvas = await html2canvas(element, {
            backgroundColor: '#ffffff',
            scale: 2, // Higher quality
            useCORS: true,
            logging: false,
        });

        const image = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = image;
        link.download = `${fileName}.png`;
        link.click();
    } catch (error) {
        console.error("Image export failed:", error);
    }
};
